"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.object.assign.js");

var _axios = _interopRequireDefault(require("axios"));

function BuzzSetting() {
  var settingObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _axios["default"].defaults = Object.assign(_axios["default"].defaults, settingObj);
}

var _default = BuzzSetting;
/**
 * @function
 * @name BuzzSetting - 请求包的默认全局设置
 * @desc 一般在入口处配置一次即可，使用中如需改动可以再次调用
 * @param {string} [url] 请求地址
 * @param {string} [baseURL] 请求的基础地址，如：//app.zhuanzhuan.com（默认）
 * @param {string} [headers] post请求头设置，也可以在默认设置中就配置好，如：application/json（默认）
 * @param {function} [beforeRequestFn] 在请求之前的参数处理
 * @param {function} [beforeResponseFn] 在请求之后的参数处理
 * @param {function} [globalTips] 全局错误提示的回调函数，Buzz会把错误参数的string传入该函数
 * @param {function} [catchError] 全局错误上报的回调函数，Buzz会把错误相关参数传入该函数
 * @param {number} [timeout] 全局超时设置
 * @example
 * import { BuzzSetting } from '@zz-biz/request';
 * // 示例1
 * BuzzSetting({  // 初次引用可以在应用入口处配置一些基础设置
 *  baseURL: '//crmapi.zhuanspirit.com',
 *  globalTips: (err: any) => {
 *    Toast.fail(err || '网络错误');
 *  }
 * });
 */

exports["default"] = _default;